import React, { useEffect, useState } from "react";
import api from "../../services/api";
import brindemeLogo from "../../assets/images/svgs/logo-brindeme-purple.svg";

export const AuthTemplate = ({ children }) => {
    const [logo, setLogo] = useState(null);
    const [promo, setPromo] = useState({ enabled: false, html: null });
    const [loaded, setLoaded] = useState(false);
    // Garante que o logo da Brinde.me apareça por no mínimo 600ms antes do crossfade.
    const [minTimePassed, setMinTimePassed] = useState(false);

    useEffect(() => {
        api.get('/login-config').then(res => {
            setLogo(res.data?.logo || null);
            setPromo(res.data?.promo || { enabled: false, html: null });
        }).catch(() => {
            // Sem config (ex.: tenant não resolvido): cai no layout sem logo/promo.
        }).finally(() => setLoaded(true));

        const timer = setTimeout(() => setMinTimePassed(true), 600);
        return () => clearTimeout(timer);
    }, []);

    // Só há HTML de divulgação depois que o fetch resolve, o tempo mínimo do logo
    // passou e a promo vem ativa/preenchida. Enquanto carrega — e quando não há
    // conteúdo — o painel fica só com o logo da Brinde.me.
    const showPromoHtml = loaded && minTimePassed && !!(promo?.enabled && promo?.html);

    return (
        <main id="auth">
            <section className="login-panel">
                <div className="login-brand">
                    {logo && <img id="logo" src={logo} alt="" />}
                </div>
                <div className="login-content">
                    {children}
                </div>
                <footer className="login-footer">
                    <a href="https://brinde.me" target="_blank" rel="noreferrer">
                        Plataforma Brinde.me
                    </a>
                </footer>
            </section>
            <section className={`promo-panel ${showPromoHtml ? 'has-promo' : ''}`}>
                {/* Fallback/loading: logo da Brinde.me centralizado sobre o degradê */}
                <div className="promo-brand" aria-hidden={showPromoHtml}>
                    <img src={brindemeLogo} alt="Brinde.me" />
                </div>
                {/* HTML da divulgação (super-admin): entra com fade in por cima do logo */}
                <div
                    className="promo-html"
                    dangerouslySetInnerHTML={{ __html: showPromoHtml ? promo.html : '' }}
                />
            </section>
        </main>
    );
}

export default AuthTemplate;
